import EmailIcon from "@mui/icons-material/Email";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CONTACT_EMAIL, getEmailHref } from "@/app/lib/constants";
import Heading from "./Heading";
import ProfileImage, { ProfileImageProps } from "./ProfileImage";

const smallGridTemplateAreas = `
"photo"
"heading"
"body"
`;
const largeGridTemplateAreas = `
"photo heading heading heading"
"body body body body"
`;

interface ContentProps {
  profileImageProps: ProfileImageProps;
}

const Content: React.FC<ContentProps> = ({ profileImageProps }) => {
  return (
    <Box
      data-testid="landing-page-content"
      sx={{
        p: 3,
        display: "grid",
        gap: 2,
        gridTemplateAreas: {
          xs: smallGridTemplateAreas,
          sm: largeGridTemplateAreas,
        },
      }}
    >
      <Box
        sx={{
          gridArea: "photo",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
        }}
      >
        <ProfileImage {...profileImageProps} />
      </Box>
      <Box sx={{ gridArea: "heading" }}>
        <Heading>Hi, I&apos;m Nichole</Heading>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: 500,
          }}
        >
          Full-Stack Developer&nbsp;
          <Typography
            variant="sacramento"
            sx={{
              fontSize: {
                xs: "34px",
                sm: "38px",
              },
            }}
          >
            and yogi!
          </Typography>
        </Typography>
      </Box>
      <Box sx={{ gridArea: "body" }}>
        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: "1.25rem",
              sm: "1.5rem",
            },
            maxWidth: "md",
          }}
        >
          Based in Orlando, Florida, my passion lies in crafting intuitive,
          well-built experiences for the customer. I have assumed roles such as
          Technical Lead, providing mentorship to colleagues, and collaborating
          within agile, cross-functional teams.
        </Typography>
        <Button
          variant="contained"
          startIcon={<EmailIcon />}
          href={getEmailHref()}
          sx={{ mt: 3 }}
          aria-label={`Contact Nichole via email at ${CONTACT_EMAIL}`}
        >
          Contact me
        </Button>
      </Box>
    </Box>
  );
};

export default Content;
